import React from "react";
import { Button as AntButton } from "react_reusable_components";
import Styles from "./button.module.scss";

export default function Button({ children, ...restProps }) {
  return (
    <AntButton className={Styles.densoButton} {...restProps}>
      {children}
    </AntButton>
  );
}
